import DirectoryView from "./Directory.vue"

const base = "/directory"

export default [
    {
        path: base,
        name: "directoryview",
        component: DirectoryView
    },
]
